export default __webpack_public_path__ + "static/media/largeDemo.23d91a0d.png";